import {
    areTopAndSecondLevelDomainsSame,
    isSuperbetWebDomain,
} from '@app/utils/domainHelpers';
import BannerDto, { BannerUsers } from './BannerDto';
import { BannerDirectus } from '@src/federations/shared/cms/types/Banner';
import { extractActionType } from '../cmsShared/clickHandlerMapper';

export function mapBanner(dto: BannerDto): BannerDirectus {
    const link = getBannerUrl(dto.link);

    return {
        link,
        kind: 'directus',
        title: dto.title,
        image: dto.image,
        backgroundImage: dto.backgroundImage,
        description: dto.description || '',
        linkDescription: dto.callToActionText || '',
        actionType: extractActionType(link, dto.howToOpen),
        id: dto.id.toString(),
        variant: dto.variant,
        buttonText: dto.buttonText,
        iconName: dto.iconName,
        showToLoggedInUsers: showBannerToLoggedInUsers(dto.users),
        showToLoggedOutUsers: showBannerToLoggedOutUsers(dto.users),
        showToNewUsersDevice: showBannerToNewUsersDevice(dto.users),
        showToReturningUsersDevice: showBannerToReturningUsersDevice(dto.users),
        startDate: new Date(dto.startDateMs),
        endDate: new Date(dto.endDateMs),
        step: 'step' in dto.additionalData ? dto.additionalData.step : undefined,

    };
}

function showBannerToLoggedInUsers(users: BannerUsers[]): boolean {
    return users.includes(BannerUsers.All) || users.includes(BannerUsers.LoggedIn);
}

function showBannerToLoggedOutUsers(users: BannerUsers[]): boolean {
    return users.includes(BannerUsers.All) || users.includes(BannerUsers.LoggedOut);
}

function showBannerToNewUsersDevice(users: BannerUsers[]): boolean {
    return users.includes(BannerUsers.All) || users.includes(BannerUsers.NewUserDevice);
}

function showBannerToReturningUsersDevice(users: BannerUsers[]): boolean {
    return users.includes(BannerUsers.All) || users.includes(BannerUsers.ReturningUserDevice);
}

function getBannerUrl(link: string): string {
    if (!link || link.startsWith('/') || link.startsWith('?')) {
        return link;
    }
    const { hostname } = new URL(link);

    if (
        areTopAndSecondLevelDomainsSame(hostname, window.location.hostname)
        && isSuperbetWebDomain(hostname)
        && isSuperbetWebDomain(window.location.hostname)
    ) {
        return getPathName(link);
    } else {
        return link;
    }
}

function getPathName(link: string): string {
    const { pathname, search } = new URL(link);
    return pathname + search;
}
